module.exports = __webpack_public_path__ + "img/1690STOCL_APP_logo.c15e3980.png";